import { useAppDispatch } from '../hooks/redux'
import http from './http'
import { getSubjectId } from "../pages/biomarkers/[id]/IndicatorsAndSignals";

const DELAY_TIMEOUT = 100

export const getUser = async (user: any) => {
  const res = await new Promise((resolve) =>
    setTimeout(() => resolve({}), DELAY_TIMEOUT)
  )
  return res
}
// export const get
// export const put
// export const delete
// export const post

const PER_PAGE = 100
const PER_PAGE_INTERPRETATION = 1000

export const getSubjects = async (item: any) => {
  const res = await http.get(`/api/core/theme/subject?per_page=${PER_PAGE}`)
  return res.data
}
export const updateSubject = async (item: any) => {
  const res = await http.put(`/api/core/theme/subject`, item)
  return res.data
}
export const deleteSubject = async (item: any) => {
  const res = await http.remove(`/api/core/theme/subjects/${item._id}`, {})
  return res.data
}
export const postSubject = async (item: any) => {
  const res = await http.post(`/api/core/theme/subject`, item)
  return res.data
}

export const getIndicators = async (item: any) => {
  const res = await http.get(`/api/core/theme/indicator?filter[subjectIds]=${getSubjectId()}&per_page=${PER_PAGE}`)
  console.log('ressss', res.data)
  res.data = res.data || {}
  res.data.data = res.data.data || {}

  res.data.data.items = (res.data.data.items || []).map((it: any) => {
    return { ...it, age: null }
  });
  return res.data;
}
export const updateIndicator = async (item: any) => {
  const res = await http.put(`/api/core/theme/indicator`, item)
  return res.data
}
export const deleteIndicator = async (item: any) => {
  const res = await http.remove(`/api/core/theme/indicators/${item._id}`, {})
  return res.data
}
export const postIndicator = async (item: any) => {
  const res = await http.post(`/api/core/theme/indicator`, item)
  return res.data
}

export const getRecommendations = async (item: any) => {
  const res = await http.get(`/api/core/theme/recommendation?filter[subjectIds]=${getSubjectId()}&per_page=${PER_PAGE}`)
  return res.data
}
export const updateRecommendation = async (item: any) => {
  const res = await http.put(`/api/core/theme/recommendation`, {})
  return res.data
}
export const deleteRecommendation = async (item: any) => {
  const res = await http.remove(`/api/core/theme/recommendations/${item._id}`, {})
  return res.data
}
export const postRecommendation = async (item: any) => {
  const res = await http.post(`/api/core/theme/recommendation`, {})
  return res.data
}

export const getSignals = async (item: any) => {
  const res = await http.get(`/api/signal?per_page=${PER_PAGE}`)
  return res.data
}
export const updateSignal = async (item: any) => {
  const res = await http.put(`/api/signal`, item)
  return res.data
}
export const deleteSignal = async (item: any) => {
  const res = await http.remove(`/api/signal`, {})
  return res.data
}
export const postSignal = async (item: any) => {
  const res = await http.post(`/api/signal`, item)
  return res.data
}

export const getInterpretation = async (item: any) => {
  const res = await http.get(`/api/core/theme/interpretation?filter[subjectIds]=${getSubjectId()}&per_page=${PER_PAGE_INTERPRETATION}`)
  return res.data
}
export const updateInterpretation = async (item: any) => {
  const res = await http.put(`/api/core/theme/interpretation`, {})
  return res.data
}
export const deleteInterpretation = async (item: any) => {
  const res = await http.remove(`/api/core/theme/interpretations/${item._id}`, {})
  return res.data
}
export const postInterpretation = async (item: any) => {
  const res = await http.post(`/api/core/theme/interpretation`, item)
  return res.data
}

export const getReports = async (params: {
  userId?: string;
  limit?: number;
  offset?: number;
  startDate?: string;
  endDate?: string;
}) => {
  const queryParams = new URLSearchParams();
  if (params.userId) queryParams.append('userId', params.userId);
  if (params.limit) queryParams.append('limit', params.limit.toString());
  if (params.offset) queryParams.append('offset', params.offset.toString());
  if (params.startDate) queryParams.append('startDate', params.startDate);
  if (params.endDate) queryParams.append('endDate', params.endDate);
  
  const res = await http.get(`/api/lab-results/reports?${queryParams.toString()}`);
  return res.data;
}

export const createReport = async (reportData: any) => {
  const res = await http.post(`/api/lab-results/reports`, reportData);
  return res.data;
}

export const getReportById = async (reportId: string) => {
  const res = await http.get(`/api/lab-results/reports/${reportId}`);
  return res.data;
}

export const deleteReport = async (reportId: string) => {
  const res = await http.remove(`/api/lab-results/reports/${reportId}`, {});
  return res.data;
}

export const exportReport = async (reportId: string, format: 'json' | 'xlsx') => {
  const res = await http.http.get(`/api/lab-results/reports/${reportId}/export?format=${format}`, {
    responseType: format === 'xlsx' ? 'blob' : 'json'
  });
  return res.data;
}
